const AuditLogin = (state = [], action) => {
    switch (action.type) {
        case 'ADMIN_AUDITLOGIN_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default AuditLogin